import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button, LoaderButton } from 'idsk-react-components';
import { useSuccessMessageContext } from '../../../../../context/SuccessMessageContext';
import { ObalMaterialu } from '../../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuFormData';
import { ClientResponse } from '../../../../../model/ClientResponse';
import { ClientStatus } from '../../../../../model/ClientStatus';

interface Props {
  setObalMaterialu: (obalData: ObalMaterialu) => void;
  fillSystemDataClient(...args): Promise<ClientResponse<ObalMaterialu>>;
  fillSystemDataStatus: ClientStatus;
}

const ObalVseobecnyFillSystemDataButton = ({
  setObalMaterialu,
  fillSystemDataStatus,
  fillSystemDataClient,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    stadium,
    stadiumUuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, stadium: string, stadiumUuid: string }>();

  const {
    clearMessages,
    displaySuccess,
  } = useSuccessMessageContext();

  const onFillDataClick = async (): Promise<void> => {
    const respose = await fillSystemDataClient(type, year, index, stadiumUuid, stadium);
    setObalMaterialu(respose.data);
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <ConfirmModal
      question="Naozaj si prajete automaticky vyplniť formulár?"
      description="Po vykonaní tejto funkcionality budú prepísané všetky údaje v tomto formulári."
      cancelButtonText="Nie"
      confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
      openButton={(
        <LoaderButton
          className="fill-obal-data-vseobecny-button"
          buttonStyle="third"
          size="large"
          onClick={clearMessages}
          loading={fillSystemDataStatus.loading}
          disableOutsideClickWhileLoading
        >
          Vyplniť údajmi zo systému
        </LoaderButton>
          )}
      doAfterConfirm={onFillDataClick}
    />
  );
};

export default ObalVseobecnyFillSystemDataButton;
